import UserModel from 'Models/UserModel';
import clientStore from 'Root/store/modules/client';

export default function client(store) {
  return [
    {
      name: 'client',
      path: '/client',
      component: () => import('Root/pages/client/Client.vue'),
      meta: {
        roles: [
          UserModel.ROLES.CUSTOMER.id,
        ],
        authorizedOnly: true,
      },
      beforeEnter(to, from, next) {
        let redirectOptions;

        if (redirectOptions) {
          next(redirectOptions);
          return;
        }

        if (!store.hasModule('client')) {
          const options = {};
          if (store.state.client) {
            options.preserveState = true;
          }

          store.registerModule('client', clientStore, options);
        }

        next();
      },

      redirect: { name: 'client__orders' },

      children: [
        {
          name: 'client__orders',
          path: 'orders',
          component: () => import('Root/pages/client/ClientOrders.vue'),
        },
        {
          path: 'orders/:id',
          name: 'client__order-progress',
          component: () => import('Root/pages/client/orderProgress/OrderProgress.vue'),
        },
      ],
    },
  ];
}
